import React, { useEffect, useRef, useState } from 'react';

const ImageUpload = ({ id, width, height, imageUrl, onUploadChange }) => {
   const fileInputRef = useRef(null);

   const onInputClick = (event) => {
      event.target.value = '';
   };
   const onFileUpload = () => {
      window.addEventListener('focus', () => {}, { once: true });
      if (fileInputRef.current) {
         fileInputRef.current.click();
      }
   };
   const onFileChanged = (e) => {
      const files = e.target.files;
      if (files[0] !== undefined) {
         const fr = new FileReader();
         fr.readAsDataURL(files[0]);
         fr.addEventListener('load', async () => {
            onUploadChange({
               url: fr.result,
               file: files[0],
               name: files[0].name,
            });
         });
      } else {
      }
   };
   return (
      <div
         style={{
            width: 'fit-content',
            height: 'auto',
            position: 'relative',
         }}
      >
         <img
            style={{
               margin: '5px',
               width: width,
               height: height,
               objectFit: 'cover',
               aspectRatio: 1,
               borderRadius: '4px',
               // backgroundColor: "rgba(237, 0, 138, 0.1)",
               border: '1px solid rgb(237, 0, 138)',
            }}
            src={imageUrl}
            alt=''
         />
         <div
            style={{
               position: 'absolute',
               top: '5px',
               right: '5px',
            }}
            onClick={onFileUpload}
         >
            <p
               style={{
                  padding: '5px 10px',
                  margin: '5px',
                  backgroundColor: 'rgb(237, 0, 138)',
                  color: 'rgb(255, 255, 255)',
                  borderRadius: '4px',
                  cursor: 'pointer',
               }}
            >
               อัปโหลด
            </p>
         </div>
         <input
            ref={fileInputRef}
            style={{
               display: 'none',
            }}
            id={id ?? 'upload-image'}
            type='file'
            accept='image/*'
            onChange={onFileChanged}
            onClick={onInputClick}
         />
      </div>
   );
};
export default ImageUpload;
